import { Access, Delegate } from "../../../access/types.ts";
import { AwsAccesses } from "../aws/accesses.ts";

export const AwsRdsAccesses = {
  resource: Access({
    label: "Database",
    description: "Grant user access to database",
    delegation: {
      aws: Delegate({
        resource: "aws",
        accesses: AwsAccesses,
        key: "resource",
      }),
    },
    generated: {},
    maturity: "preview",
    parameters: {
      arn: {
        type: "static",
        label: "Database ARN",
      },
      resourceId: {
        type: "static",
        label: "Database resource ID",
      },
      vpcId: {
        type: "static",
        label: "VPC ID",
      },
    },
    render: { locator: "vpcId" } as const,
  }),
};

export type AwsRdsAccesses = typeof AwsRdsAccesses;
